import React from "react";
import NumberFormat from "react-number-format";
import { FormGroup, Input, Label, UncontrolledTooltip } from "reactstrap";
import { isBiro } from "../../utils/helper";

const FormField = ({ label, description, type, value, onChange }) => {
  const radios = ["Cash", "Imbreng"];
  return (
    <div className="row mb-3">
      <div className="col-md-5 d-flex align-items-center">
        <Label>
          {label}
        </Label>
      </div>

      <div className="col-md-7">
        {type === "radio" ? (
          radios.map((radio) => (
            <FormGroup check className="d-inline mr-2" onClick={() => onChange(radio)}>
              <Label check>
                <Input type="radio" name={label} value={value} checked={value === radio} /> {radio}
              </Label>
            </FormGroup>
          ))
        ) : (
          <NumberFormat
            className="form-control"
            value={value}
            onValueChange={onChange}
            thousandSeparator={true}
          />
        )}
      </div>
    </div>
  );
};

export default FormField;
